module.exports = __webpack_public_path__ + "img/16l011-03.bc9bf4a7.png";